export const botonWhatsapp = {
  nombre: "Mainfud",
  chat: [
    "¡Hola! ¿Quieres ver cómo funciona Mainfud? ¿Quieres un demo?",
    "o si tienes alguna duda, ¡escríbenos!",
  ],
  numeros: ["34675464502", "573002888529"],
};
